const mobileMenuToggle = document.querySelector('.js-mobile-menu-toggle');
const mobileMenu = document.querySelector('.js-mobile-menu');

if (mobileMenuToggle && mobileMenu) {
	mobileMenuToggle.addEventListener('click', () => {
		document.body.classList.toggle('has-mobile-menu-open');
		mobileMenuToggle.classList.toggle('is-open');
		mobileMenu.classList.toggle('is-open');
	});

	const submenusToggle = mobileMenu.querySelectorAll('.js-mobile-submenu-toggle');
	submenusToggle.forEach((submenuToggle) => {
		submenuToggle.addEventListener('click', (event) => {
			event.target?.closest('li')?.classList?.toggle('is-open');
		});
	});
}
